import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseResponse } from '../models/rest/baseResponse';

export interface IEmbedTokenResponse extends BaseResponse {
  EmbedToken: string;
}

@Injectable({ providedIn: 'root' })
export class PowerBiService {

  constructor(private _httpClient: HttpClient) {}

  getDashboardEmbedToken(tenantId: string, groupId: string,
                         clientId: string, dashboardId: string): Observable<IEmbedTokenResponse> {
    const requestUrl = `Reports/PowerBi/EmbedToken?TenantId=${tenantId}&GroupId=${groupId}&ReportId=${dashboardId}&ClientId=${clientId}&ReportType=Dashboards`;
    return this._httpClient.get<IEmbedTokenResponse>(requestUrl);
  }

  getReportEmbedToken(tenantId: string, groupId: string,
                      clientId: string, reportId: string): Observable<IEmbedTokenResponse> {
    const requestUrl = `Reports/PowerBi/EmbedToken?TenantId=${tenantId}&GroupId=${groupId}&ReportId=${reportId}&ClientId=${clientId}&ReportType=Reports`;
    return this._httpClient.get<IEmbedTokenResponse>(requestUrl);
  }

}
